import React from "react";
import icons from "./icons";

export default function ScaffoldIcon(props) {
  const { language = "english" } = props;

  let background;
  if (language === "english") background = icons.english
  if (language === "spanish") background = icons.spanish

  return (
    <div className="scaffold-group">
      <img src={background} className='scaffold-background' />
      <img src={icons.scaffoldIcon} className="scaffold-icon" />
    </div>
  );
}
